

























import {
	defineComponent,
	ref,
} from '@vue/composition-api';
import IconDropdown from '@front-app/components/dropdowns/IconDropdown.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PublicLink from '../buttons/PublicLink.vue';

export default defineComponent({
	components: {
		IconDropdown,
		FontAwesomeIcon,
		PublicLink,
	},
	setup() {
		return {
			isOpen: ref(false),
		};
	},
});
